import ShareholderCount from '@rebuild/materials/shared/shareholder/ShareholderCount.vue';

export const componentMap = {
	full: ShareholderCount
};
